import PropTypes from "prop-types";
import React, { Children, useCallback, useState } from "react";
import { Tab, Tabs } from "react-bootstrap";
import styled, { withTheme } from "styled-components";

import PrimaryButton from "../../ui-library/Buttons/PrimaryButton/PrimaryButton";
import SecondaryBtn from "../../ui-library/Buttons/SecondaryButton/SecondaryButton";

const StyledDiv = styled.div`
  display: flex;
  flex-direction: column;
`;

const StyledButtonsWrapper = styled.div`
  display: flex;
  flex-direction: row;

  .custom-tab-button:not(:last-child) {
    margin-right: 10px;
  }

  .custom-tab-button {
    color: ${(props) => props?.theme?.white};
    ${(props) => {
      return props?.$maxButtonSize
        ? `max-width: ${props?.$maxButtonSize}px;`
        : null;
    }}
  }
`;

const StyledTabsWrapper = styled.div`
  margin-top: 10px;

  .tab-content {
    background-color: ${(props) => props?.theme?.whiteSmoke};
    padding: 25px;
  }

  @media (max-width: 576px) {
    margin-left: -25px;
    margin-right: -25px;
  }
`;

export const TabButton = (props) => {
  return props.children;
};

export const CustomTabContent = (props) => {
  return props.children;
};

const CustomTabs = (props) => {
  const { defaultActiveKey = "", maxButtonSize, children, onSelect } = props;

  const [activeKey, setActiveKey] = useState(defaultActiveKey);

  const tabButtonClickHandler = useCallback(
    (eventKey) => {
      setActiveKey(eventKey);

      if (onSelect) {
        onSelect(eventKey);
      }
    },
    [onSelect]
  );

  const renderTabButton = (child) => {
    if (child.type === TabButton) {
      if (activeKey === child.props.eventKey) {
        return (
          <PrimaryButton
            className="custom-tab-button"
            size="sm"
            onClick={() => tabButtonClickHandler(child.props.eventKey)}
          >
            {child}
          </PrimaryButton>
        );
      }

      return (
        <SecondaryBtn
          className="custom-tab-button"
          size="sm"
          onClick={() => tabButtonClickHandler(child.props.eventKey)}
        >
          {child}
        </SecondaryBtn>
      );
    }
  };

  return (
    <StyledDiv>
      <StyledButtonsWrapper $maxButtonSize={maxButtonSize}>
        {Children?.map(children, (child) => renderTabButton(child))}
      </StyledButtonsWrapper>
      <StyledTabsWrapper>
        <Tabs activeKey={activeKey} variant="pills">
          {Children?.map(children, (child) => {
            if (child.type === CustomTabContent) {
              return <Tab eventKey={child.props.eventKey}>{child}</Tab>;
            }
          })}
        </Tabs>
      </StyledTabsWrapper>
    </StyledDiv>
  );
};

CustomTabs.propTypes = {
  defaultActiveKey: PropTypes.string.isRequired,
  maxButtonSize: PropTypes.number,
  onSelect: PropTypes.func,
};

CustomTabs.defaultProps = {
  defaultActiveKey: "",
  maxButtonSize: null,
  onSelect: null,
};

export default withTheme(CustomTabs);
